import ServoDiagram from "../../../../docs/_images/hw_ff_servo.png";
import ServoSchematics from "../../../../docs/_images/hw_ff_servo_schem.png";
import * as React from 'react';
export default {
  ServoDiagram,
  ServoSchematics,
  React
};